<template>
  <div v-editable="blok" class="menu-banner">
    <a class="menu-banner-link" :href="getLinkFieldUrl(blok.link)" :target="blok.link?.target">
      <figure class="menu-banner-image">
        <NuxtImg v-if="blok.image?.filename" provider="storyblok" loading="lazy" :src="blok.image.filename" :alt="`Banner Image ${blok.image.alt}`" fetchpriority="low" class="menu-banner-image-element" :width="315" :height="420" />
      </figure>
    </a>
  </div>
</template>
<script setup>
  defineProps({ blok: Object });
</script>
